$( ->
  $(document).on 'click', 'body.microsite p.alert .reset-form', ->
    $('#job_filter form').get()[0].reset()
)
